module.exports = __webpack_public_path__ + "static/media/top.b9c06b88.svg";